import Config from 'scoreboard/components/bootslide/bootslide-menu'
import configBackground from 'scoreboard/dashboards/widgets/wob-background-menu'
import wobTablePaddingMenu from 'scoreboard/dashboards/widgets/wob-table-padding-menu'
import WidgetConfigMenu from 'scoreboard/dashboards/widgets/widget-config-menu'
import fontSizeMenu from 'scoreboard/dashboards/widgets/font-size-menu'
import chartAccessoryLabel from 'scoreboard/dashboards/widgets/chart/config/config-chart-accessory-label'

const ChartTableConfigMenu = WidgetConfigMenu.extend({
	label: 'charts.editTable',

	allowDuplicate: false,

	initialize: function (opt) {
		WidgetConfigMenu.prototype.initialize.apply(this, arguments)
		this.chartWidget = opt.chartWidget
	},

	typeSpecificTargets: function () {
		const chartWidget = this.chartWidget
		const table = this.model

		const options = []

		options.push(chartAccessoryLabel(this, table, chartWidget.chart, 'charts.setDataTableLabel'))

		options.push(toggle('charts.chart.series.label', 'showSeriesLabel', table))
		if (chartWidget.chart.get('plotType') !== 'tree-map') {
			options.push(toggle('charts.chart.series.color', 'showSeriesColor', table))
		}
		options.push(toggle('charts.chart.chartData', 'showData', table))
		options.push(fontSizeMenu(this.chartWidget.properties, {
			property: 'tableFontSize',
			updateModel: value => {
				this.options.widgetUpdater.applyUpdate((widgetModel, widgetView) => {
					const chartWob = widgetView._findChartWob()
					chartWob.widget.properties.set('tableFontSize', value)
				}, { types: [ 'chart-table' ] })
			},
			// #36717 Fonts as relative offsets to the below size
			baseSize: 14
		}))
		options.push(wobTablePaddingMenu(this.model.properties))
		options.push(configBackground(this.model.properties))

		return options
	}
})

function toggle (label, prop, widgetModel) {
	return {
		type: 'toggle',
		label: label,
		contentView: Config.WidgetToggleProperty.extend({
			property: { label: label, name: prop }
		}),
		model: widgetModel.properties
	}
}

export default ChartTableConfigMenu

ChartTableConfigMenu.__filename__ = 'dashboards/widgets/chart/config/chart-table-config-menu.js'
